import styled from '@emotion/styled';
import { Pause, Play, RotateCw } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { theme } from 'styles/theme/theme';
import { millisToMinutesAndSeconds } from 'modules/overlay-v2/domain/utils/convert-time';
import { resetTime } from 'modules/overlay-v2/store/time/actions';
import { setPeriod, toggleTimer } from 'modules/overlay-v2/store/time/time';
import useTime from 'modules/overlay-v2/ui/hooks/use-time';
import useTimer from 'modules/overlay-v2/ui/hooks/use-timer';
import Block from '../components/block';
import Counter from '../components/counter';
import Text from '../components/text';
import ValueBlock from '../components/value-block';

export function Period() {
  const dispatch = useDispatch();
  const { period } = useTime();
  const { timer, setTimer, addToTimer, isActive } = useTimer();

  const onClickToggler = () => {
    dispatch(toggleTimer());
  };

  const onChangePeriod = (num: number) => {
    setTimer(0);
    dispatch(setPeriod(num));
  };

  const onClickReset = () => {
    dispatch(resetTime());
  };

  return (
    <Block className={'flex-center flex-col'} headerText={'Тайм'} style={{ gap: 6 }}>
      <div className={'flex items-center'} style={{ width: '100%', height: 30, justifyContent: 'space-between' }}>
        <div
          className={'flex-center'}
          style={{ height: '100%', width: 70, background: theme.colors.AccentNaplesYellow }}
          onClick={onClickToggler}
        >
          {isActive ? <Pause size={20} fill={'white'} color={'white'} /> : <Play size={20} fill={'white'} color={'white'} />}
        </div>
        <Counter value={period} setValue={onChangePeriod} />
        <ValueBlock
          text={millisToMinutesAndSeconds(timer)}
          textSize={'large'}
          className={'flex-center'}
          style={{ width: 70, height: 30 }}
        />
      </div>
      <div className={'flex items-center justify-between'} style={{ gap: 4, width: '100%' }}>
        <Button onClick={() => addToTimer(-10 * 1000)}>
          <Text size={'medium'} color={'white'} className="flex-center">
            -10
          </Text>
        </Button>
        <Button onClick={() => addToTimer(-5 * 1000)}>
          <Text size={'medium'} color={'white'} className="flex-center">
            -5
          </Text>
        </Button>
        <Button onClick={() => addToTimer(-1 * 1000)}>
          <Text size={'medium'} color={'white'} className="flex-center">
            -1
          </Text>
        </Button>
        <Button onClick={() => addToTimer(1000)}>
          <Text size={'medium'} color={'white'} className="flex-center">
            +1
          </Text>
        </Button>
        <Button onClick={() => addToTimer(5 * 1000)}>
          <Text size={'medium'} color={'white'} className="flex-center">
            +5
          </Text>
        </Button>
        <Button onClick={() => addToTimer(10 * 1000)}>
          <Text size={'medium'} color={'white'} className="flex-center">
            +10
          </Text>
        </Button>
        <RotateCw size={16} color={theme.colors.WhiteGray} onClick={onClickReset} />
      </div>
    </Block>
  );
}

const Button = styled.button`
  background: ${theme.colors.Gray};
  width: 26px;
  height: 20px;
  border: none;
`;
